__turbopack_context__.v({
  "detailsCard": "JhM0sq_detailsCard",
  "detailsItem": "JhM0sq_detailsItem",
  "detailsItemLabel": "JhM0sq_detailsItemLabel",
  "discountLabel": "JhM0sq_discountLabel",
  "discountLabelText": "JhM0sq_discountLabelText",
  "discountValue": "JhM0sq_discountValue",
  "summaryItem": "JhM0sq_summaryItem",
  "summaryItemBoldText": "JhM0sq_summaryItemBoldText",
  "summaryItemBoldTextLarge": "JhM0sq_summaryItemBoldTextLarge",
  "summaryItemText": "JhM0sq_summaryItemText",
  "summaryWrapper": "JhM0sq_summaryWrapper",
});
